/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclRole {
    getFixupPrototypeFunction() { return DashboardDefinitionAclRole.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclRole>): DashboardDefinitionAclRole {
        let obj = Object.assign(new DashboardDefinitionAclRole(), model);
        DashboardDefinitionAclRole.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclRole>): DashboardDefinitionAclRole {
        if (!model) return null;
        return DashboardDefinitionAclRole.newInstance(<DashboardDefinitionAclRole> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclRole) {
        if (!obj) return;

        models.DashboardDefinitionAclRole.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclRole): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAclRole.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    id: string;

    tenant_id: string;

    name: string;

}
